export default "__VITE_ASSET__jiM_lxVW__"